var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0 && (t[p] = s[p]);
    if (null != s && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for (p = Object.getOwnPropertySymbols(s); i < p.length; i++) e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]) && (t[p[i]] = s[p[i]]);
    }
    return t;
};

import { ticks } from "@visactor/vrender-components";

import { isContinuous } from "@visactor/vscale";

import { BaseComponent } from "../base/base-component";

import { CompilableData } from "../../compile/data";

import { eachSeries, getSeries } from "../../util/model";

import { mergeSpec } from "@visactor/vutils-extension";

import { ChartEvent, LayoutZIndex } from "../../constant";

import { animationConfig } from "../../animation/utils";

import { degreeToRadian, pickWithout, isEqual, array, get, isArray, isBoolean, isFunction, isNil, isValid, maxInArray } from "@visactor/vutils";

import { DEFAULT_TITLE_STYLE, transformAxisLineStyle } from "./util";

import { transformAxisLabelStateStyle, transformStateStyle, transformToGraphic } from "../../util/style";

import { DataView } from "@visactor/vdataset";

import { GridEnum, registerAxis as registerVGrammarAxis, registerGrid as registerVGrammarGrid } from "@visactor/vgrammar-core";

import { registerComponentMark } from "../../mark/component";

import { Factory } from "../../core/factory";

import { GroupFadeIn, GroupTransition } from "@visactor/vrender-components";

import { GroupFadeOut } from "@visactor/vrender-core";

import { scaleParser } from "../../data/parser/scale";

import { registerDataSetInstanceParser, registerDataSetInstanceTransform } from "../../data/register";

import { getFormatFunction } from "../util";

export class AxisComponent extends BaseComponent {
    getOrient() {
        return this._orient;
    }
    getScale() {
        return this._scale;
    }
    getScales() {
        return this._scales;
    }
    getTickData(index = 0) {
        return this._tickData[index];
    }
    get visible() {
        return this._visible;
    }
    getInverse() {
        return this._inverse;
    }
    getCoordinateType() {
        return this._coordinateType;
    }
    constructor(spec, options) {
        var _a;
        super(spec, options), this.specKey = "axes", this._scales = [], this._tickData = [], 
        this._visible = !0, this._tick = void 0, this._visible = null === (_a = spec.visible) || void 0 === _a || _a, 
        this._coordinateType = "none";
    }
    _getNeedClearVRenderComponents() {
        return [];
    }
    getVRenderComponents() {
        var _a, _b;
        return array(null === (_b = null === (_a = this._axisMark) || void 0 === _a ? void 0 : _a.getProduct()) || void 0 === _b ? void 0 : _b.getGroupGraphicItem());
    }
    created() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        if (super.created(), this.setSeriesAndRegionsFromSpec(), this.initEvent(), this.initScales(), 
        this.updateSeriesScale(), this._shouldComputeTickData() && this._initData(), this._visible) {
            const axisMark = this._createMark({
                type: "component",
                name: `axis-${this.getOrient()}`
            }, {
                componentType: "angle" === this.getOrient() ? "circleAxis" : "axis",
                mode: this._spec.mode,
                noSeparateStyle: !0,
                skipTheme: !0
            });
            if (this._axisMark = axisMark, axisMark.setZIndex(this.layoutZIndex), isValid(this._spec.id) && axisMark.setUserId(this._spec.id), 
            this._marks.addMark(axisMark), null === (_a = this._spec.grid) || void 0 === _a ? void 0 : _a.visible) {
                const gridMark = this._createMark({
                    type: "component",
                    name: `axis-${this.getOrient()}-grid`
                }, {
                    componentType: "angle" === this.getOrient() ? GridEnum.circleAxisGrid : GridEnum.lineAxisGrid,
                    mode: this._spec.mode,
                    noSeparateStyle: !0,
                    skipTheme: !0
                });
                gridMark.setZIndex(null !== (_f = null !== (_d = null === (_c = null === (_b = this._spec.grid) || void 0 === _b ? void 0 : _b.style) || void 0 === _c ? void 0 : _c.zIndex) && void 0 !== _d ? _d : null === (_e = this._spec.grid) || void 0 === _e ? void 0 : _e.zIndex) && void 0 !== _f ? _f : LayoutZIndex.Axis_Grid), 
                gridMark.setInteractive(!1), this._marks.addMark(gridMark), this._gridMark = gridMark;
            }
            if (isBoolean(this._spec.interactive) && this._marks.forEach((m => m.setInteractive(this._spec.interactive))), 
            !1 !== this._option.animation && !1 !== get(this._option.getChart().getSpec(), "animation") && !0 === this._spec.animation) {
                const axisAnimateConfig = animationConfig(null === (_g = Factory.getAnimationInKey("axis")) || void 0 === _g ? void 0 : _g(), {
                    appear: null !== (_j = null !== (_h = this._spec.animationAppear) && void 0 !== _h ? _h : get(this._option.getChart().getSpec(), "animationAppear.axis")) && void 0 !== _j ? _j : get(this._option.getChart().getSpec(), "animationAppear"),
                    disappear: null !== (_l = null !== (_k = this._spec.animationDisappear) && void 0 !== _k ? _k : get(this._option.getChart().getSpec(), "animationDisappear.axis")) && void 0 !== _l ? _l : get(this._option.getChart().getSpec(), "animationDisappear"),
                    enter: null !== (_o = null !== (_m = this._spec.animationEnter) && void 0 !== _m ? _m : get(this._option.getChart().getSpec(), "animationEnter.axis")) && void 0 !== _o ? _o : get(this._option.getChart().getSpec(), "animationEnter"),
                    exit: null !== (_q = null !== (_p = this._spec.animationExit) && void 0 !== _p ? _p : get(this._option.getChart().getSpec(), "animationExit.axis")) && void 0 !== _q ? _q : get(this._option.getChart().getSpec(), "animationExit"),
                    update: null !== (_s = null !== (_r = this._spec.animationUpdate) && void 0 !== _r ? _r : get(this._option.getChart().getSpec(), "animationUpdate.axis")) && void 0 !== _s ? _s : get(this._option.getChart().getSpec(), "animationUpdate")
                });
                axisAnimateConfig.enter && (axisAnimateConfig.update[0].customParameters = {
                    enter: axisAnimateConfig.enter[0]
                }), this._marks.forEach((m => m.setAnimationConfig(axisAnimateConfig)));
            }
        }
    }
    _shouldComputeTickData() {
        return this.getVisible() || this._spec.forceInitTick;
    }
    _initData() {
        const tickData = this._initTickDataSet(this._tickTransformOption());
        tickData.target.addListener("change", this._forceLayout.bind(this)), this._tickData = [ new CompilableData(this._option, tickData) ];
    }
    collectData(depth, rawData) {
        const data = [];
        return eachSeries(this._regions, (s => {
            var _a;
            let field = this.collectSeriesField(depth, s);
            if (field = isArray(field) ? isContinuous(this._scale.type) ? field : [ field[0] ] : [ field ], 
            depth || (this._dataFieldText = s.getFieldAlias(field[0])), field) {
                const viewData = s.getViewData();
                if (rawData) field.forEach((f => {
                    data.push(s.getRawDataStatisticsByField(f, !1));
                })); else if (viewData && viewData.latestData && viewData.latestData.length) {
                    const seriesData = null === (_a = s.getViewDataStatistics) || void 0 === _a ? void 0 : _a.call(s);
                    field.forEach((f => {
                        var _a;
                        (null === (_a = null == seriesData ? void 0 : seriesData.latestData) || void 0 === _a ? void 0 : _a[f]) && data.push(seriesData.latestData[f]);
                    }));
                }
            }
        }), {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        }), data;
    }
    isSeriesDataEnable() {
        let enable = !0;
        return eachSeries(this._regions, (s => {
            var _a;
            isArray(null === (_a = s.getViewDataStatistics()) || void 0 === _a ? void 0 : _a.latestData) && (enable = !1);
        }), {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        }), enable;
    }
    setSeriesAndRegionsFromSpec() {
        const {seriesId: seriesId, seriesIndex: seriesIndex, regionId: regionId, regionIndex: regionIndex} = this._spec;
        isValid(seriesId) && (this._seriesUserId = array(seriesId)), isValid(regionId) && (this._regionUserId = array(regionId)), 
        isValid(seriesIndex) && (this._seriesIndex = array(seriesIndex)), isValid(regionIndex) && (this._regionIndex = array(regionIndex)), 
        this._regions = this._option.getRegionsInUserIdOrIndex(this._regionUserId, this._regionIndex), 
        this.layout.layoutBindRegionID = this._regions.map((x => x.id));
    }
    getBindSeriesFilter() {
        return {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        };
    }
    initEvent() {
        this.event.on(ChartEvent.scaleUpdate, {
            filter: ({model: model}) => (null == model ? void 0 : model.id) === this.id
        }, this.effect.scaleUpdate.bind(this));
        const viewStatistics = getSeries(this._regions, {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        }).map((s => s.getViewDataStatistics())).filter((v => !!v));
        viewStatistics.length > 1 ? this._option.dataSet.multipleDataViewAddListener(viewStatistics, "change", (() => {
            this.updateScaleDomain();
        })) : 1 === viewStatistics.length && viewStatistics[0].target.addListener("change", (() => {
            this.updateScaleDomain();
        })), eachSeries(this._regions, (s => {
            s.event.on(ChartEvent.rawDataUpdate, {
                filter: ({model: model}) => (null == model ? void 0 : model.id) === s.id
            }, (() => {
                this._clearRawDomain();
            }));
        }), {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        });
    }
    updateScaleDomain() {}
    _clearRawDomain() {}
    onLayoutEnd(ctx) {
        this.updateScaleRange();
        this.event.emit(ChartEvent.scaleUpdate, {
            model: this,
            value: "range"
        }), super.onLayoutEnd(ctx);
    }
    computeData(updateType) {
        !this._tickData || !this._tickData.length || "force" !== updateType && isEqual(this._scale.range(), [ 0, 1 ]) || this._tickData.forEach((tickData => {
            tickData.getDataView().reRunAllTransform(), tickData.updateData();
        }));
    }
    initScales() {
        this._scales = [ this._scale ];
        const groups = [];
        if (eachSeries(this._regions, (s => {
            const g = s.getGroups();
            g && groups.push(g);
        }), {
            userId: this._seriesUserId,
            specIndex: this._seriesIndex
        }), 0 !== groups.length) {
            const depth = maxInArray(groups.map((g => g.fields.length)));
            for (let i = 1; i < depth; i++) {
                const scale = this._scale.clone();
                this._scales.push(scale);
            }
        }
    }
    _compareSpec(spec, prevSpec) {
        const result = super._compareSpec(spec, prevSpec);
        return result.reMake ? result : (result.reRender = !0, (null == prevSpec ? void 0 : prevSpec.type) !== (null == spec ? void 0 : spec.type) ? (result.reMake = !0, 
        result) : (result.reMake = [ "grid", "subGrid", "tick", "subTick", "label", "domainLine", "title" ].some((k => {
            var _a, _b;
            return (null === (_a = null == prevSpec ? void 0 : prevSpec[k]) || void 0 === _a ? void 0 : _a.visible) !== (null === (_b = null == spec ? void 0 : spec[k]) || void 0 === _b ? void 0 : _b.visible);
        })), result));
    }
    _delegateAxisContainerEvent(component) {
        0 === component.listenerCount("*") && component.addEventListener("*", ((event, type) => this._delegateEvent(component, event, type)));
    }
    _getAxisAttributes() {
        const spec = this._spec, axisAttrs = {
            orient: this.getOrient(),
            select: !0 !== this._option.disableTriggerEvent && spec.select,
            hover: !0 !== this._option.disableTriggerEvent && spec.hover
        };
        if (spec.domainLine && spec.domainLine.visible ? axisAttrs.line = transformAxisLineStyle(spec.domainLine) : axisAttrs.line = {
            visible: !1
        }, spec.label && spec.label.visible) {
            const labelSpec = pickWithout(spec.label, [ "style", "formatMethod", "state" ]);
            axisAttrs.label = labelSpec, spec.label.style && (axisAttrs.label.style = isFunction(spec.label.style) ? (datum, index, data, layer) => {
                var _a;
                const style = spec.label.style(datum.rawValue, index, datum, data, layer);
                return transformToGraphic(mergeSpec({}, null === (_a = this._theme.label) || void 0 === _a ? void 0 : _a.style, style));
            } : transformToGraphic(spec.label.style)), (spec.label.formatMethod || spec.label.formatter) && (axisAttrs.label.formatMethod = this._getLabelFormatMethod()), 
            spec.label.state && (axisAttrs.label.state = transformAxisLabelStateStyle(spec.label.state));
        } else axisAttrs.label = {
            visible: !1
        };
        if (spec.tick && spec.tick.visible ? (axisAttrs.tick = {
            visible: spec.tick.visible,
            length: spec.tick.tickSize,
            inside: spec.tick.inside,
            alignWithLabel: spec.tick.alignWithLabel,
            dataFilter: spec.tick.dataFilter
        }, spec.tick.style && (axisAttrs.tick.style = isFunction(spec.tick.style) ? (value, index, datum, data) => {
            var _a;
            const style = spec.tick.style(value, index, datum, data);
            return transformToGraphic(mergeSpec({}, null === (_a = this._theme.tick) || void 0 === _a ? void 0 : _a.style, style));
        } : transformToGraphic(spec.tick.style)), spec.tick.state && (axisAttrs.tick.state = transformStateStyle(spec.tick.state))) : axisAttrs.tick = {
            visible: !1
        }, spec.subTick && spec.subTick.visible ? (axisAttrs.subTick = {
            visible: spec.subTick.visible,
            length: spec.subTick.tickSize,
            inside: spec.subTick.inside,
            count: spec.subTick.tickCount
        }, spec.subTick.style && (axisAttrs.subTick.style = isFunction(spec.subTick.style) ? (value, index, datum, data) => {
            var _a;
            const style = spec.subTick.style(value, index, datum, data);
            return transformToGraphic(mergeSpec({}, null === (_a = this._theme.subTick) || void 0 === _a ? void 0 : _a.style, style));
        } : transformToGraphic(spec.subTick.style)), spec.subTick.state && (axisAttrs.subTick.state = transformStateStyle(spec.subTick.state))) : axisAttrs.subTick = {
            visible: !1
        }, spec.title && spec.title.visible) {
            const _a = spec.title, {autoRotate: autoRotate, angle: angle, style: titleStyle = {}, background: titleBackgroundSpec, state: titleState, shape: titleShapeSpec} = _a, restTitleAttrs = __rest(_a, [ "autoRotate", "angle", "style", "background", "state", "shape" ]);
            let titleTextStyle, titleAngle = angle;
            "left" !== spec.orient && "right" !== spec.orient || autoRotate && isNil(titleAngle) && (titleAngle = "left" === spec.orient ? -90 : 90, 
            titleTextStyle = DEFAULT_TITLE_STYLE[spec.orient]), axisAttrs.title = Object.assign(Object.assign({}, restTitleAttrs), {
                autoRotate: !1,
                angle: titleAngle ? degreeToRadian(titleAngle) : null,
                textStyle: mergeSpec({}, titleTextStyle, transformToGraphic(titleStyle)),
                pickable: !1 !== titleStyle.pickable,
                childrenPickable: !1 !== titleStyle.pickable,
                state: {}
            }), titleShapeSpec && titleShapeSpec.visible ? (axisAttrs.title.shape = Object.assign(Object.assign({}, titleShapeSpec), {
                style: transformToGraphic(titleShapeSpec.style)
            }), titleShapeSpec.state && (axisAttrs.title.state.shape = transformStateStyle(titleShapeSpec.state))) : axisAttrs.title.shape = {
                visible: !1
            }, titleBackgroundSpec && titleBackgroundSpec.visible ? (axisAttrs.title.background = Object.assign(Object.assign({}, titleBackgroundSpec), {
                style: transformToGraphic(titleBackgroundSpec.style)
            }), titleBackgroundSpec.state && (axisAttrs.title.state.background = transformStateStyle(titleBackgroundSpec.state))) : axisAttrs.title.background = {
                visible: !1
            }, titleState && (axisAttrs.title.state.text = transformStateStyle(titleState));
        } else axisAttrs.title = {
            visible: !1
        };
        return spec.background && spec.background.visible ? (axisAttrs.panel = {
            visible: !0
        }, spec.background.style && (axisAttrs.panel.style = transformToGraphic(spec.background.style)), 
        spec.background.state && (axisAttrs.panel.state = transformStateStyle(spec.background.state))) : axisAttrs.panel = {
            visible: !1
        }, axisAttrs;
    }
    _getGridAttributes() {
        const spec = this._spec;
        return {
            alternateColor: spec.grid.alternateColor,
            alignWithLabel: spec.grid.alignWithLabel,
            style: isFunction(spec.grid.style) ? () => (datum, index) => {
                var _a, _b;
                const style = spec.grid.style(null === (_a = datum.datum) || void 0 === _a ? void 0 : _a.rawValue, index, datum.datum);
                return transformToGraphic(mergeSpec({}, null === (_b = this._theme.grid) || void 0 === _b ? void 0 : _b.style, style));
            } : transformToGraphic(spec.grid.style),
            subGrid: !1 === spec.subGrid.visible ? {
                visible: !1
            } : {
                type: "line",
                visible: spec.subGrid.visible,
                alternateColor: spec.subGrid.alternateColor,
                style: transformToGraphic(spec.subGrid.style)
            }
        };
    }
    _getLabelFormatMethod() {
        const {formatMethod: formatMethod, formatter: formatter} = this._spec.label, {formatFunc: formatFunc} = getFormatFunction(formatMethod, formatter);
        return formatFunc ? (value, datum, index) => formatFunc(datum.rawValue, datum, formatter) : null;
    }
    _initTickDataSet(options, index = 0) {
        registerDataSetInstanceParser(this._option.dataSet, "scale", scaleParser), registerDataSetInstanceTransform(this._option.dataSet, "ticks", ticks);
        return new DataView(this._option.dataSet, {
            name: `${this.type}_${this.id}_ticks_${index}`
        }).parse(this._scales[index], {
            type: "scale"
        }).transform({
            type: "ticks",
            options: options
        }, !1);
    }
    _tickTransformOption() {
        const tick = this._tick || {}, label = this._spec.label || {}, {tickCount: tickCount, forceTickCount: forceTickCount, tickStep: tickStep, tickMode: tickMode} = tick, {style: labelStyle, formatMethod: labelFormatter, minGap: labelGap} = label;
        return {
            sampling: !1 !== this._spec.sampling,
            tickCount: tickCount,
            forceTickCount: forceTickCount,
            tickStep: tickStep,
            tickMode: tickMode,
            axisOrientType: this._orient,
            coordinateType: this._coordinateType,
            labelStyle: labelStyle,
            labelFormatter: labelFormatter,
            labelGap: labelGap
        };
    }
    addTransformToTickData(options, execute) {
        this._tickData.forEach((tickData => {
            var _a;
            null === (_a = null == tickData ? void 0 : tickData.getDataView()) || void 0 === _a || _a.transform(options, execute);
        }));
    }
    dataToPosition(values) {
        return this._scale.scale(values);
    }
}

AxisComponent.specKey = "axes";

export const registerAxis = () => {
    registerVGrammarAxis(), registerVGrammarGrid(), registerComponentMark(), Factory.registerAnimation("axis", (() => ({
        appear: {
            custom: GroupFadeIn
        },
        update: {
            custom: GroupTransition
        },
        exit: {
            custom: GroupFadeOut
        }
    })));
};
//# sourceMappingURL=base-axis.js.map
